import React, { Component, Fragment } from 'react'
import { observer, inject } from 'mobx-react'
import { observable, action, toJS, makeObservable } from 'mobx'
import { withRouter } from 'react-router-dom'
import { get } from 'utils/lodash.utils'

import { areObjectsEqual } from 'utils/helpers.utils'
import { injectFontList } from 'utils/fonts.utils'
import { FORM_KEYS } from 'constants/embeddableItems.constants'

import EmbedForm from './previews/embed-form/EmbedForm'
import TextLink from './previews/TextLink'
import Button from './previews/Button'
import Badge from './previews/Badge'
import Slider from './previews/Slider'
import EmbedPaymentPage from './previews/EmbedPaymentPage'
import Banner from './previews/Banner'

import IframeListener from '../IframeListener'

const embeddableItems = {
  [FORM_KEYS.textLink]: TextLink,
  [FORM_KEYS.button]: Button,
  [FORM_KEYS.banner]: Banner,
  [FORM_KEYS.badge]: Badge,
  [FORM_KEYS.slider]: Slider,
  [FORM_KEYS.embedForm]: EmbedForm,
  [FORM_KEYS.embedPaymentPage]: EmbedPaymentPage,
}

@withRouter
@inject('embeddableItemsStore', 'productsStore', 'sellerFontsStore', 'currenciesStore')
@observer
class EmbeddableItem extends Component {
  @observable formData = {
    form: FORM_KEYS.textLink,
    embedPrefs: {},
  }
  @observable loading = true

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  async componentDidMount() {
    const { productLink, isPreview, isCreate, productsStore, sellerFontsStore, currenciesStore } = this.props

    if (!isPreview && !isCreate) {
      await currenciesStore.fetchList()
      await this.fetchProductLink()
    } else {
      const sellerId = get(productLink, 'sellerId', '') || get(productLink, 'seller.id', '')

      this.setFormData(productLink)

      /* Custom Fonts activation - seller id for pubisher */
      sellerFontsStore.fetchFullList({ sellerId }).then((resp) => {
        if (resp.success) {
          injectFontList(resp.data.list)
        }
      })

      if (isCreate) {
        const isSlider = productLink.form === FORM_KEYS.slider
        if (isSlider) {
          productsStore.setExpands(['covers'])
          productsStore.fetchList({
            username: productLink.seller.username,
            id: toJS(productLink.embedPrefs.productIds),
            canBeSoldViaShop: true,
          })
        }
      }
      this.setLoading(false)
    }
  }

  componentDidUpdate() {
    const { productLink, isPreview } = this.props
    if (isPreview && !areObjectsEqual(this.formData, productLink)) {
      this.setFormData(productLink)
    }
  }

  componentWillUnmount() {
    const { productsStore } = this.props
    productsStore.resetExpands()
  }

  doTransparent = (form, transparent) => {
    if (document && transparent && form === FORM_KEYS.embedPaymentPage) {
      document.body.style.backgroundColor = 'transparent'
    }
  }

  fetchProductLink = async () => {
    const {
      embeddableItemsStore,
      productsStore,
      sellerFontsStore,
      isPreview,
      match: {
        params: { token },
      },
    } = this.props
    const resp = await embeddableItemsStore.fetchItem(token, {
      expand: ['seller', 'product', 'affiliate_node'],
    })
    const { data = {} } = resp || {}

    this.setFormData(data)

    const { form, productId, seller: { username } = {}, embedPrefs: { productIds, transparent } = {} } = data || {}

    /* Transparent bg for body */
    this.doTransparent(form, transparent && transparent !== 'false')

    /* Custom Fonts activation - seller username for pubisher */
    sellerFontsStore.fetchFullList({ username }).then((resp) => {
      if (resp.success) {
        injectFontList(resp.data.list)
      }
    })

    const isSlider = form === FORM_KEYS.slider

    if (!isPreview && productId) {
      await productsStore.fetchItem(productId, {
        username,
        expand: ['pricing_plans', 'covers'],
      })
    }
    if (!productsStore.list.length && isSlider) {
      productsStore.setExpands(['covers'])
      await productsStore.fetchList({
        username,
        id: toJS(productIds),
        canBeSoldViaShop: true,
      })
    }
    this.setLoading(false)
  }

  @action setFormData = (formData = {}) => (this.formData = formData)
  @action setLoading = (loading) => (this.loading = loading)

  render() {
    const { isPreview } = this.props
    const { form } = this.formData || {}

    if (this.loading || !form) {
      return null
    }

    const Item = embeddableItems[form]

    return (
      <Fragment>
        <Item productLink={this.formData} isPreview={isPreview} />
        <IframeListener />
      </Fragment>
    )
  }
}

export default EmbeddableItem
